import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    addedUser: {},
  },
  reducers: {
    setAddedUser: (state, action) => {
      state.addedUser = action.payload;
    },
  },
});

export const { setAddedUser } = userSlice.actions;

export default userSlice.reducer;

export const getAddedUser = (state) => state?.user?.addedUser;
